<div class="marquee-row">
	<div class="marquee-row-inner">
		<div class="flex items-stretch border-b border-secondary/30 overflow-hidden">
			<button
				class="race-control-btn px-2 py-2 rounded-lg border-border-default border-1 mr-3 hover:bg-surface-container-high cursor-pointer flex items-center gap-2"
				(click)="openRaceControlPanel()"
				title="Race Control"
			>
				<i class="bi bi-flag-fill text-base"></i>
				<span class="race-control-text text-xs font-medium">Race Control</span>
			</button>

			<div class="marquee-viewport flex-1 py-1.5" [style.--marquee-duration]="marqueeDuration()">
				<div class="marquee-track">
					<span class="marquee-item" *ngFor="let message of raceControlCurrentMessages()">
						<span
							class="text-xs font-semibold tracking-wide px-3 py-0.5 rounded-full"
							[style.background-color]="message.backgroundColor"
							[style.color]="message.foregroundColor"
						>
							{{ message.text }}
						</span>
						<span class="marquee-separator px-6 opacity-30">◆</span>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
